import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls window to top on route change, EXCEPT when only the language
 * segment (/mx <-> /en) is switched. When the URL contains a hash, scroll
 * to that section instead of the page top.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const prev = useRef(pathname);

  useEffect(() => {
    const prevPath = prev.current;
    prev.current = pathname;

    // Strip leading language segment
    const strip = (p) => {
      const m = p.match(/^\/(mx|en)(\/.*)?$/);
      return m ? m[2] || "/" : p;
    };

    const prevBase = strip(prevPath);
    const nextBase = strip(pathname);

    if (prevBase === nextBase && !hash) {
      // Only language changed and no hash target — do not scroll
      return;
    }

    if (hash) {
      // Wait for DOM paint, then scroll to the target block
      const id = hash.replace(/^#/, "");
      requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          window.scrollTo({ top: 0, left: 0, behavior: "auto" });
        }
      });
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
}
